import axios from "axios";
import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v3_add_user = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/user`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_user = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/user`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_users = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/user/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_user_access = async (userName, userId, userAccess) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/user/${userId}`;
    return customAxios.patch(url, { userAccess: userAccess, userName: userName }, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_userProfile = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/userProfile`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_update_profile = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/userProfile`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_profile_detail = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/userProfile/detail`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
